import React, { useEffect, useState, useRef } from "react";
import { Users, Smile, Clock } from "lucide-react";

const NumberCounter = ({ target, duration, icon, label, isVisible }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isVisible) return; // Only start counting when the section is visible

    let start = 0;
    const increment = target / duration;

    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        clearInterval(timer);
        setCount(target);
      } else {
        setCount(Math.ceil(start));
      }
    }, 10);

    return () => clearInterval(timer);
  }, [target, duration, isVisible]);

  return (
    <div className="flex flex-col items-center justify-center p-4 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
      <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">
        {count}+
      </div>
      <div className="text-gray-600 flex items-center space-x-2">
        {icon}
        <span className="text-sm md:text-lg">{label}</span>
      </div>
    </div>
  );
};

const CounterWidget = () => {
  const [isVisible, setIsVisible] = useState(false);
  const widgetRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target); // Stop observing once visible
        }
      },
      {
        threshold: 0.5, // Trigger when 50% of the widget is visible
      }
    );

    if (widgetRef.current) {
      observer.observe(widgetRef.current);
    }

    return () => {
      if (widgetRef.current) {
        observer.unobserve(widgetRef.current);
      }
    };
  }, []);

  return (
    <div ref={widgetRef} className="flex items-center justify-center p-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full max-w-4xl">
        <NumberCounter
          target={3570}
          duration={200}
          icon={<Users className="w-5 h-5 md:w-6 md:h-6" />}
          label="Trained student"
          isVisible={isVisible}
        />
        <NumberCounter
          target={45}
          duration={300}
          icon={<Smile className="w-5 h-5 md:w-6 md:h-6" />}
          label="Event Hosted"
          isVisible={isVisible}
        />
        <NumberCounter
          target={8}
          duration={250}
          icon={<Clock className="w-5 h-5 md:w-6 md:h-6" />}
          label="Number of Academy"
          isVisible={isVisible}
        />
      </div>
    </div>
  );
};

export default CounterWidget;
